import * as React from 'react'
import { cn } from '../lib/cn'
import { Button } from './button'
import { Input } from './input'

/** Quick reasons for a flag, proposal, card, or obligation (#558). Free text stays optional. */
export const DISMISS_REASONS = ['Wrong / not applicable', 'Already handled', "Customer isn't the one waiting", 'Will do later'] as const

/**
 * Dismiss in one click. The button records no reason (or the optional text, when it is filled).
 * A chip records that chip's words. Nothing here asks the person to type first.
 */
export function DismissControl({
  onDismiss,
  pending = false,
  label = 'Dismiss',
  className,
}: {
  onDismiss: (reason: string | null) => void
  pending?: boolean
  /** Accessible name of the one-click button. */
  label?: string
  className?: string
}) {
  const [text, setText] = React.useState('')
  const send = (reason: string | null) => {
    if (pending) return
    onDismiss(reason)
  }
  return (
    <div data-slot="dismiss-control" className={cn('flex min-w-0 flex-wrap items-center gap-1.5', className)}>
      <Button type="button" size="sm" variant="ghost" disabled={pending} title="Dismiss (x)" onClick={() => send(text.trim() || null)}>
        {label}
      </Button>
      <fieldset aria-label="Quick reasons" className="m-0 flex min-w-0 flex-wrap gap-1 border-0 p-0">
        {DISMISS_REASONS.map((reason) => (
          <Button key={reason} type="button" size="sm" variant="outline" disabled={pending} onClick={() => send(reason)}>
            {reason}
          </Button>
        ))}
      </fieldset>
      <Input
        aria-label="Dismissal reason (optional)"
        placeholder="Other reason (optional)"
        maxLength={500}
        value={text}
        disabled={pending}
        className="h-7 w-44 text-xs"
        onChange={(event) => setText(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== 'Enter') return
          event.preventDefault()
          event.stopPropagation()
          send(text.trim() || null)
        }}
      />
    </div>
  )
}
